import { render, staticRenderFns } from "./PurchasesProfileButton.vue?vue&type=template&id=38e0f844&scoped=true"
import script from "./PurchasesProfileButton.vue?vue&type=script&lang=js"
export * from "./PurchasesProfileButton.vue?vue&type=script&lang=js"
import style0 from "./PurchasesProfileButton.vue?vue&type=style&index=0&id=38e0f844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0f844",
  null
  
)

export default component.exports